import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { InfoModal } from 'components/Layout';
import GuestDetailsForm from './GuestDetailsForm';
import { useDetailsBooking } from 'lib/hooks';
import { useSoftAmendmentContext } from './SoftAmendmentProvider';
import { isFourWeeksAfterCheckout } from './helpers';
import { formattedName } from 'lib/formatters';

const GuestDetailsModal = ({ isOpen, closeModal, ...rest }) => {
  const { booking } = useDetailsBooking();
  const name = booking.reservation.leadGuest.name;
  const email = booking.travelArranger.email;
  const phoneNumber = booking.travelArranger.phone;
  const qffNumber = booking.reservation.leadGuest.qffNumber || '';
  const businessNumber = booking.travelArranger.businessRegistrationNumber || '';
  const disableQffFields = isFourWeeksAfterCheckout(booking.reservation.checkOutDateTime);
  const { onSubmit, complete, loading, error } = useSoftAmendmentContext();

  useEffect(() => {
    if (complete) {
      closeModal();
    }
  }, [complete, closeModal]);

  return (
    <InfoModal
      shouldCloseOnOverlayClick={!loading}
      shouldCloseOnEsc={!loading}
      width="default"
      contentLabel=""
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      disableClose={loading}
      {...rest}
    >
      <InfoModal.body p="5">
        <GuestDetailsForm
          name={formattedName(name)}
          email={email}
          phoneNumber={phoneNumber}
          qffNumber={qffNumber}
          businessNumber={businessNumber}
          disableQffFields={disableQffFields}
          error={error}
          onSubmit={onSubmit}
          onCancel={closeModal}
          isSubmitting={loading}
        />
      </InfoModal.body>
    </InfoModal>
  );
};

GuestDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func,
};

export default GuestDetailsModal;
